// removed by extract-text-webpack-plugin
module.exports = {"page":"_2o8TEh_zPS8J2k6uDg87ZB","page-scrollbarhider":"_1SgRpG_ZHG6gZM58QO1dyK","pageScrollbarhider":"_1SgRpG_ZHG6gZM58QO1dyK","page-scroller":"_3D5FWn-HEdFer4ONtnUWqC","pageScroller":"_3D5FWn-HEdFer4ONtnUWqC","page-content":"_10Xx4f_LEGmPbFJM1vIy_4","pageContent":"_10Xx4f_LEGmPbFJM1vIy_4"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/scrollpage.css
// module id = 312
// module chunks = 0